import script from "./DataTableExtin.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTableExtin.vue?vue&type=script&setup=true&lang=js"

import "./DataTableExtin.vue?vue&type=style&index=0&id=2d1c70a0&lang=scss"

const __exports__ = script;

export default __exports__